<template>
  <div class="ui two columns grid segment">
    <div class="row">
      <div class="column">
        <h3 class="ui dividing header">
          Reservation type information
        </h3>
        <abstractTable :data="reservationTypeInfo"
                       :definitionTable="true"
                       :definitionTableWidth="'30%'"
                       :classes="'ui compact definition table'"
        />
      </div>

      <div class="column">
        <h3 class="ui dividing header">
          Default package information
        </h3>
        <abstractTable :data="defaultPackageInfo"
                       :definitionTable="true"
                       :definitionTableWidth="'40%'"
                       :classes="'ui compact definition table'"
        />
      </div>
    </div>
    <div class="row">
      <div class="column">
        <div class="ui blue left labeled icon button" style="background-color: #092442" @click="perivous()">
          <i class="left arrow icon"></i>
          Perivous
        </div>
      </div>

      <div class="column">
        <div class="ui blue right floated right labeled icon button"
             style="background-color: #092442"
             @click="save()">
          <i class="right arrow icon"></i>
          Submit
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    reservationType: { type: Object, required: true },
    defaultPackage: { type: Object, required: true }
  },
  computed: {
    reservationTypeInfo () {
      return {
        name: this.reservationType.name,
        price: this.reservationType.price + ' LE',
        hours: this.reservationType.hours || 0,
        minutes: this.reservationType.minutes
      }
    },
    defaultPackageInfo () {
      return {
        quantity: this.defaultPackage.quantity,
        'Unit Measurement Id': this.defaultPackage.unit_measurement_id,
        start_at: window.moment(this.defaultPackage.start_at).format('LLLL') || '-',
        description: this.defaultPackage.description,
        medical_machines: 'Laser'
      }
    }
  },
  methods: {
    perivous () {
      this.$emit('reservationType-goToStepTwo')
    },
    save () {
      this.$emit('reservationType-confirmation')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/steps/reservation_types/new_reservation_type_steps/ReviewStep.vue